module.exports = __webpack_public_path__ + "img/icon_six_tit.83d35220.png";